import { Status } from './models';
import type { ReducerState } from './redux';

export const getChatStatus = (state: ReducerState): Status => state.chat.status;

export const isChatLoaded = (state: ReducerState): boolean =>
  getChatStatus(state) === Status.Loaded;
